class CartDrawer extends HTMLElement {
	constructor() {
		super();

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);
		this.querySelector("#CartDrawer-Overlay").addEventListener(
			"click",
			this.close.bind(this)
		);
		this.setHeaderCartIconAccessibility();
	}

	setHeaderCartIconAccessibility() {
		const cartLink = document.querySelector("#cart-icon-bubble");
		cartLink.setAttribute("role", "button");
		cartLink.setAttribute("aria-haspopup", "dialog");

		cartLink.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(cartLink);
		});

		cartLink.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(cartLink);
			}
		});
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);
		const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
		if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
			this.setSummaryAccessibility(cartDrawerNote);
		// here the animation doesn't seem to always get triggered. A timeout seem to help
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				const containerToTrapFocusOn = this.classList.contains("is-empty")
					? this.querySelector(".drawer__inner-empty")
					: document.getElementById("CartDrawer");
				const focusElement =
					this.querySelector(".drawer__inner") ||
					this.querySelector(".drawer__close");
				trapFocus(containerToTrapFocusOn, focusElement);
			},
			{ once: true }
		);

		document.body.classList.add("cart-overflow-hidden");
		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("cart-overflow-hidden");
		document.body.classList.remove("overflow-hidden");

		setTimeout(() => {
			let notification = this.querySelector(".notification");

			if (notification) {
				const activeItem = this.querySelector(
					`.cart-item[data-product-id="${this.productId}"`
				);
				notification.classList.remove("notification-open");
				activeItem?.classList.remove("active");
			}
		}, 1000);
	}

	setSummaryAccessibility(cartDrawerNote) {
		cartDrawerNote.setAttribute("role", "button");
		cartDrawerNote.setAttribute("aria-expanded", "false");

		if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
			cartDrawerNote.setAttribute(
				"aria-controls",
				cartDrawerNote.nextElementSibling.id
			);
		}

		cartDrawerNote.addEventListener("click", (event) => {
			event.currentTarget.setAttribute(
				"aria-expanded",
				!event.currentTarget.closest("details").hasAttribute("open")
			);
		});

		cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
	}

	renderContents(parsedState) {
		this.querySelector(".drawer__inner").classList.contains("is-empty") &&
			this.querySelector(".drawer__inner").classList.remove("is-empty");
		this.productId = parsedState.id;
		this.getSectionsToRender().forEach((section) => {
			const sectionElement = section.selector
				? document.querySelector(section.selector)
				: document.getElementById(section.id);
			sectionElement.innerHTML = this.getSectionInnerHTML(
				parsedState.sections[section.id],
				section.selector
			);
		});

		let notification = this.querySelector(".notification");

		if (notification) {
			const activeItem = this.querySelector(
				`.cart-item[data-product-id="${this.productId}"`
			);
			notification.classList.add("notification-open");
			activeItem.classList.add("active");
		}

		setTimeout(() => {
			this.querySelector("#CartDrawer-Overlay").addEventListener(
				"click",
				this.close.bind(this)
			);
			this.open();
		});
	}

	getSectionInnerHTML(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector).innerHTML;
	}

	getSectionsToRender() {
		return [
			{
				id: "cart-drawer",
				selector: "#CartDrawer",
			},
			{
				id: "cart-icon-bubble",
			},
		];
	}

	getSectionDOM(html, selector = ".shopify-section") {
		return new DOMParser()
			.parseFromString(html, "text/html")
			.querySelector(selector);
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
	getSectionsToRender() {
		return [
			{
				id: "CartDrawer",
				section: "cart-drawer",
				selector: ".drawer__inner",
			},
			{
				id: "cart-icon-bubble",
				section: "cart-icon-bubble",
				selector: ".shopify-section",
			},
		];
	}
}

customElements.define("cart-drawer-items", CartDrawerItems);

if (!customElements.get("cart-note")) {
	customElements.define(
		"cart-note",
		class CartNote extends HTMLElement {
			constructor() {
				super();

				this.addEventListener(
					"input",
					debounce((event) => {
						const body = JSON.stringify({ note: event.target.value });
						fetch(`${routes.cart_update_url}`, {
							...fetchConfig(),
							...{ body },
						});
					}, ON_CHANGE_DEBOUNCE_TIMER)
				);
			}
		}
	);
}

/* ---------------------------------------------------------------
   Coral Reef Alliance tracker.

   Appended to the theme's own drawer script rather than added to
   snippets/cart-drawer.liquid: the drawer is 34KB of core Liquid and
   the highest-stakes markup on the site, so it is left untouched.
   Everything below is additive and self-contained — delete this block
   and the drawer is stock again.

   Why script and not Liquid: the drawer updates by replacing the
   innerHTML of .drawer__inner with freshly rendered section HTML, so
   anything rendered inside it is thrown away and re-made on every cart
   change. A MutationObserver that lives outside that subtree survives
   those swaps and re-renders the tracker each time.

   Rates are Koraru's own: $5 per one-piece, $2.50 per top and $2.50
   per bottom, so a set is $5. Anything with no rate — gift cards —
   contributes nothing, and a basket that funds nothing shows nothing
   rather than a claim that does not apply.
   --------------------------------------------------------------- */

(function () {
	var SELF = document.currentScript && document.currentScript.src;

	var RATES = {
		"Swimwear One-piece": 5,
		"Swimwear Tops": 2.5,
		"Swimwear Bottoms": 2.5,
		"Bundle": 5,
	};

	var ICON =
		'<svg class="cart-donation__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true" focusable="false">' +
		'<path d="M3 16c1.5-1.4 3-1.4 4.5 0s3 1.4 4.5 0 3-1.4 4.5 0 3 1.4 4.5 0"/>' +
		'<path d="M3 20.5c1.5-1.4 3-1.4 4.5 0s3 1.4 4.5 0 3-1.4 4.5 0 3 1.4 4.5 0"/>' +
		'<path d="M8 12V7a2.5 2.5 0 0 1 5 0v5M13 12V9a2 2 0 0 1 4 0v3"/>' +
		"</svg>";

	var writing = false;
	var queued = false;

	function styles() {
		if (!SELF || document.getElementById("cart-donation-css")) return;
		var link = document.createElement("link");
		link.id = "cart-donation-css";
		link.rel = "stylesheet";
		link.href = SELF.split("?")[0].replace(/cart-drawer\.js$/, "cart-donation.css");
		document.head.appendChild(link);
	}

	function money(value) {
		return "$" + (value % 1 === 0 ? value.toFixed(0) : value.toFixed(2));
	}

	function donation(cart) {
		var sum = 0;
		var items = (cart && cart.items) || [];
		for (var i = 0; i < items.length; i++) {
			var rate = RATES[items[i].product_type];
			if (rate) sum += rate * items[i].quantity;
		}
		return sum;
	}

	function render(amount) {
		var ctas = document.querySelector("cart-drawer .cart__ctas");
		if (!ctas) return;

		var button = ctas.querySelector("#CartDrawer-Checkout");
		var node = ctas.querySelector(".cart-donation");

		if (!button || !amount) {
			if (node) node.parentNode.removeChild(node);
			ctas.removeAttribute("data-cart-donation");
			return;
		}

		if (!node) {
			node = document.createElement("div");
			node.className = "cart-donation";
			node.innerHTML = ICON + '<span class="cart-donation__text"></span>';
		}

		if (node.nextElementSibling !== button) {
			ctas.insertBefore(node, button);
		}

		var copy =
			money(amount) + " (USD) donated to the Coral Reef Alliance with your order";
		var textEl = node.querySelector(".cart-donation__text");
		if (textEl.textContent !== copy) textEl.textContent = copy;

		ctas.setAttribute("data-cart-donation", "on");
	}

	function refresh() {
		if (writing) {
			queued = true;
			return;
		}

		fetch("/cart.js", { headers: { Accept: "application/json" } })
			.then(function (response) {
				return response.json();
			})
			.then(function (cart) {
				writing = true;
				render(donation(cart));
				setTimeout(function () {
					writing = false;
					if (queued) {
						queued = false;
						refresh();
					}
				}, 0);
			})
			.catch(function () {
				writing = false;
			});
	}

	function watch() {
		var drawer = document.querySelector("cart-drawer");
		if (!drawer) return;

		new MutationObserver(function (records) {
			for (var i = 0; i < records.length; i++) {
				var target = records[i].target;
				var el = target.nodeType === 1 ? target : target.parentElement;
				// ignore the tracker rewriting itself
				if (el && el.closest && el.closest(".cart-donation")) continue;
				refresh();
				return;
			}
		}).observe(drawer, { childList: true, subtree: true });

		refresh();
	}

	function init() {
		styles();
		watch();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();